import { styled } from '@mui/material';
import { Flex, FlexProps } from '../layout';

type AppLogoProps = FlexProps & {
  logoImg: string;
  imgStyles?: React.CSSProperties;
};
export const AppLogoText = ({ logoImg, imgStyles = {}, ...props }: AppLogoProps) => {
  return (
    <AppLogoStyledFlex alignCenter justifyCenter {...props}>
      <img src={logoImg} alt="Powered by logo" style={imgStyles} />
    </AppLogoStyledFlex>
  );
};

const AppLogoStyledFlex = styled(Flex)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));
